import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/app.css";

if (import.meta.env.DEV && !__RISEOS_UI_SYSTEM_AVAILABLE__) {
  // eslint-disable-next-line no-console
  console.warn(
    "[fieldflow] riseos-ui-system checkout not found — using fallback tokens/fonts for local development. " +
      "Paralucent and Avenir LT Pro will render as system fonts. See README.md 'Fonts & the canonical design system'."
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
